import { useState } from "react";
import { X } from "lucide-react";

const projects = [
  {
    title: "Bøgehæk · Kolding",
    desc: "45 meter bøgehæk klippet ned til nydelig form.",
    before: "https://images.pexels.com/photos/1108572/pexels-photo-1108572.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Thuja · Vejle",
    desc: "Høj thujahæk trimmet og formet på begge sider.",
    before: "https://images.pexels.com/photos/1105019/pexels-photo-1105019.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/2286895/pexels-photo-2286895.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Havepleje · Fredericia",
    desc: "Total forvandling af villahave — græs, bede og hæk.",
    before: "https://images.pexels.com/photos/302804/pexels-photo-302804.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/1108572/pexels-photo-1108572.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Liguster · Middelfart",
    desc: "Ligusterhæk med præcis formklipning.",
    before: "https://images.pexels.com/photos/259698/pexels-photo-259698.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/1105019/pexels-photo-1105019.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Bede & plantning · Haderslev",
    desc: "Nyanlagt bed og sæsonplantning.",
    before: "https://images.pexels.com/photos/32427440/pexels-photo-32427440.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/1400375/pexels-photo-1400375.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Terrasse & sti · Kolding",
    desc: "Nye fliser og pæne kanter — klar til sommeren.",
    before: "https://images.pexels.com/photos/265216/pexels-photo-265216.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after: "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

function BeforeAfter({ before, after }) {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative w-full aspect-[4/3] overflow-hidden rounded-3xl border border-brand-border select-none">
      <img src={after} alt="Efter" className="absolute inset-0 w-full h-full object-cover" />
      <div
        className="absolute inset-y-0 left-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img
          src={before}
          alt="Før"
          className="absolute inset-0 h-full w-[100vw] max-w-none object-cover"
          style={{ width: `calc(100% * 100 / ${pos})` }}
        />
      </div>
      <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -translate-x-1/2 w-0.5 bg-brand-bg" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-brand-bg border-2 border-brand-primary grid place-items-center text-brand-primary text-xs font-medium">
          ◀▶
        </div>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        aria-label="Før/efter slider"
      />
      <div className="absolute top-3 left-3 rounded-full bg-brand-bg/90 text-brand-primary px-3 py-1 text-xs uppercase tracking-widest">Før</div>
      <div className="absolute top-3 right-3 rounded-full bg-brand-primary text-brand-bg px-3 py-1 text-xs uppercase tracking-widest">Efter</div>
    </div>
  );
}

export default function Gallery() {
  return (
    <div data-testid="page-gallery">
      <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-12">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-muted mb-4">Galleri</div>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tight text-brand-text text-balance">
            Før og efter — <span className="italic text-brand-primary">se forvandlingen</span>.
          </h1>
          <p className="mt-6 text-lg text-brand-muted leading-relaxed">
            Træk i skyderen for at se forskellen på hver af vores projekter fra det sidste år.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-24">
        <div className="grid gap-8 md:grid-cols-2">
          {projects.map((p, i) => (
            <div key={i} data-testid={`gallery-item-${i}`}>
              <BeforeAfter before={p.before} after={p.after} />
              <div className="mt-4">
                <h3 className="font-display text-xl text-brand-text">{p.title}</h3>
                <p className="text-sm text-brand-muted mt-1">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
